/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */

import { useLocation, useParams } from 'react-router-dom';
import { useAppSelector } from './useAppSelector';
import { useEffect } from 'react';
import { useGetProductByFlowIdQuery } from '@/store/apis';

export const useScreenTitle = () => {
    const pathname: string = useLocation().pathname.split('/')?.[1] || '';
    const skuName = useAppSelector(state => state.productList?.currentProduct?.productName);
    const { flowId } = useParams();

    const { data: productDto } = useGetProductByFlowIdQuery(flowId!, {
        skip: !flowId,
    });

    useEffect(() => {
        document.title =
            {
                '': 'Deployment Hub - Home',
                landing: 'Deployment Hub - Home',
                error: 'Deployment Hub - Error',
                login: 'Deployment Hub - Login',
                dashboard: skuName,
                viewReport: 'Deployment Hub - View Report',
                monitor: `Monitor - ${skuName || productDto?.name}`,
            }[pathname] ?? 'Deployment Hub';
    }, [pathname, skuName, productDto?.name]);
};
